
<div v-if="indexData" class="index-stats-view">
  <graph-overview
    v-if="index.dailyIndexTotal"
    title="Index Data"
    y-axis-type="number"
    :zoom.sync="zoom"
    :scale.sync="scale"
    :stats="indexData.indexStats"
    :graph-values="[indexData.dailyIndexTotal]"
  />

  <div v-if="index.dailySalesTotal">
    <br /><br />

    <graph-overview
      title="Sales Volume"
      :date="index.date"
      :zoom.sync="zoom"
      :scale.sync="scale"
      :stats="indexData.stats"
      :graph-values="[indexData.dailySalesTotal]"
    />
  </div>
</div>
